import { useEffect } from 'react';
import { setIsMobile } from '../redux/actions/widgetActions';
import { useAppDispatch } from './store';
export var useIsMobile = function (query) {
    var dispatch = useAppDispatch();
    useEffect(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            dispatch(setIsMobile(mql.matches));
        };
        mql.addEventListener('change', onChange);
        dispatch(setIsMobile(mql.matches));
        return function () {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [query]);
};
